import React, { useState } from 'react';
import classNames from 'classnames';
import $ from 'sitewide-jquery';

import type { WorkId } from 'js/liswp/types';
import FeedbackOption from './feedback_option';

interface ReportModalProps {
  reportWork: (choices: string[], workId: WorkId, category: string) => void;
  workId: WorkId;
}

const ReportModal: React.FC<ReportModalProps> = ({ reportWork, workId }) => {
  const [choices, setChoices] = useState<string[]>([]);

  const recordChoice = (choice: string) => {
    if (choices.includes(choice)) {
      setChoices(choices.filter((c) => c !== choice));
    } else {
      setChoices([...choices, choice]);
    }
  };

  const onSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (choices.length === 0) {
      return;
    }

    reportWork(choices, workId, 'general');
    $('.modal').modal('hide');
  };

  const onCancel = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    $('.modal').modal('hide');
  };

  const submitButtonClasses = classNames('work-card-modal--submit-button', {
    valid: choices.length > 0,
  });

  return (
    <div className="work-card-modal--container">
      <div className="work-card-modal--header">
        What's the problem with this work?
      </div>
      <div className="work-card-modal--sub-header">
        We use your feedback to show you, and other academics, only high quality
        papers.
      </div>
      <div className="work-card-modal--body">
        <FeedbackOption
          onClick={() => recordChoice('spam')}
          iconName="fa-flag"
          color="red"
          text="It's inappropriate or spam"
          selected={choices.includes('spam')}
        />
        <FeedbackOption
          onClick={() => recordChoice('copyrighted_material')}
          iconName="fa-ban"
          color="brown"
          text="It's copyrighted material"
          selected={choices.includes('copyrighted_material')}
        />
        <FeedbackOption
          onClick={() => recordChoice('uploader_not_author')}
          iconName="fa-user-slash"
          color="yellow"
          text="The uploader is not an author"
          selected={choices.includes('uploader_not_author')}
        />
        <FeedbackOption
          onClick={() => recordChoice('other')}
          iconName="fa-question"
          color="gray"
          text="Something else"
          selected={choices.includes('other')}
        />
      </div>
      <div className="work-card-modal--actions">
        <div className="work-card-modal--cancel-button" onClick={onCancel}>
          Cancel
        </div>
        <button className={submitButtonClasses} onClick={onSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default ReportModal;
